// Utilidades de búsqueda compartidas. Escrito de forma sencilla (sin métodos
// que disparen polyfills) para no depender del estado de core-js.

// Normaliza: minúsculas y sin acentos (así "garcia" encuentra "García").
export function norm(s) {
  return String(s == null ? '' : s)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
}

// Coincidencia por palabras (como la mayoría de buscadores):
// "pilar garcia" encuentra "Pilar Rocío García Pérez".
// Cada palabra de la búsqueda debe aparecer en alguno de los campos.
export function tokenMatch(query, fields) {
  var q = norm(query);
  if (!q) return true;

  var arr = Array.isArray(fields) ? fields : [fields];
  var hay = '';
  for (var i = 0; i < arr.length; i++) {
    hay += ' ' + norm(arr[i]);
  }

  var words = q.split(/\s+/);
  for (var j = 0; j < words.length; j++) {
    var w = words[j];
    if (w && hay.indexOf(w) === -1) return false;
  }
  return true;
}
